var CookieNames = {
  CART_ID: 'cart-id',
  LK_TOKEN:'lkToken',
  SWITCH_USER:'X-Switch-User',
};

export default CookieNames
